<template>
  <div>
    <div class="forgot-pass-box text-center">
      <div v-if="!isCognitoEnabled" class="forgot-pwd-title" v-translate:RESER_PASSWORD_BUTTON_TITLE="lang">
        Please enter new password
      </div>

      <p v-if="eventType == 'password' && isCognitoEnabled" class="forgot-pwd-text p-0 cursor_pointer mb-30">
        <span v-translate:label_set_your_new_password_email_address="lang">The verification code was sent to</span>
        {{ obfuscatedIdentity }}
      </p>
      <div v-if="eventType == 'password' && isCognitoEnabled" class="forgot-pwd-wrapper">
        <!-- OTP Verification -->
        <p class="forgot-pwd-text p-0 f-14" v-translate:label_verification_code="lang">
          Enter verification code
        </p>
        <div class="input-verification form-group d-flex justify-content-between mb-10 align-items-center">
          <input v-model="otp[0]" name="otp1" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.focus()" required />
          <input v-model="otp[1]" name="otp2" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[2]" name="otp3" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[3]" name="otp4" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[4]" name="otp5" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[5]" name="otp6" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <img v-if="isValidOtp" src="@/assets/Checkmark.svg" alt="" class="icon-checkmark" />
        </div>
        <p v-if="eventType == 'password' && isCognitoEnabled" class="forgot-pwd-text p-0 cursor_pointer resend-text" v-translate:label_resend_code="lang" @click.prevent="resendOtp">
          Resend Code
        </p>
        <!-- OTP Verification -->
      </div>

      <div v-if="eventType == 'username'">
        <div class="form-group mb-0">
          <input v-model="username" @keyup="validateUsername(username)" :tabindex="tabindex" autocomplete="new-password" type="text" class="form-control" required />
          <label v-translate:label_username="lang">Username</label>
        </div>

        <div class="checkbox-wrapper pt-12 pb-48">
          <ul class="validation-list">
            <li>
              <span
                v-if="usernameValidation.isValidLength !== null"
                :class="{
                  success: usernameValidation.isValidLength,
                  error: !usernameValidation.isValidLength
                }"
                aria-hidden="true"
              ></span>
              <span v-else class="initial-state" aria-hidden="true"></span>
              <span class="form-check-label" v-translate:password_minchar="lang">min. 8 characters</span>
            </li>
            <li>
              <span
                v-if="usernameValidation.isValidSpecial !== null"
                :class="{
                  success: usernameValidation.isValidSpecial,
                  error: !usernameValidation.isValidSpecial
                }"
                aria-hidden="true"
              ></span>
              <span v-else class="initial-state" aria-hidden="true"></span>
              <span class="form-check-label" v-translate:label_cannot_special_character="lang">cannot begin or end with a special character (.-_@)</span>
            </li>
            <li>
              <span
                v-if="usernameValidation.isValidUnique !== null"
                :class="{
                  success: usernameValidation.isValidUnique,
                  error: !usernameValidation.isValidUnique
                }"
                aria-hidden="true"
              ></span>
              <span v-else class="initial-state" aria-hidden="true"></span>
              <span class="form-check-label" v-translate:label_must_be_unique="lang">must be unique</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="form-group mb-0">
        <input v-model="password" @keyup="validatePassword(password)" :tabindex="tabindex > 1 ? tabindex + 1 : tabindex" autocomplete="false" :type="password && password.length > 0 ? 'password' : 'text'" class="form-control" required />
        <label v-translate:PASSWORD_PLACEHOLDER="lang">Password</label>
      </div>

      <div class="checkbox-wrapper pt-12 pb-15">
        <ul class="validation-list">
          <li>
            <span
              v-if="passwordValidations.isValidLength !== null"
              :class="{
                success: passwordValidations.isValidLength,
                error: !passwordValidations.isValidLength
              }"
              aria-hidden="true"
            ></span>
            <span v-else class="initial-state" aria-hidden="true"></span>
            <span class="form-check-label" v-translate:password_minchar="lang">min. 8 characters</span>
          </li>
          <li>
            <span
              v-if="passwordValidations.isValidLetter !== null"
              :class="{
                success: passwordValidations.isValidLetter,
                error: !passwordValidations.isValidLetter
              }"
              aria-hidden="true"
            ></span>
            <span v-else class="initial-state" aria-hidden="true"></span>
            <span class="form-check-label" v-translate:pass_requirment_min_one_letter="lang">at least 1 letter</span>
          </li>
          <li>
            <span
              v-if="passwordValidations.isValidNumber !== null"
              :class="{
                success: passwordValidations.isValidNumber,
                error: !passwordValidations.isValidNumber
              }"
              aria-hidden="true"
            ></span>
            <span v-else class="initial-state" aria-hidden="true"></span>
            <span class="form-check-label" v-translate:password_onenumber="lang">at least 1 number (12345)</span>
          </li>
          <li>
            <span
              v-if="passwordValidations.isValidSpecial !== null"
              :class="{
                success: passwordValidations.isValidSpecial,
                error: !passwordValidations.isValidSpecial
              }"
              aria-hidden="true"
            ></span>
            <span v-else class="initial-state" aria-hidden="true"></span>
            <span class="form-check-label" v-translate:PASS_REQUIREMENT_MIN_ONE_SPECIAL_CHAR="lang">at least 1 symbol (!@#$%&)</span>
          </li>
        </ul>
      </div>

      <div class="form-group m-0 re-enter-pwd">
        <input v-model="newPassword" autocomplete="false" :tabindex="tabindex + 1" :type="newPassword && newPassword.length > 0 ? 'password' : 'text'" class="form-control" required />
        <label v-translate:hint_confirm_password_registration="lang">Re-enter Password</label>
        <span class="text-danger" v-show="password !== newPassword && !isPwdEmpty" v-translate:pweb_error_password_notmatch="lang">Passwords do not match. Please try again.</span>
      </div>

      <div class="text-center pt-80">
        <button class="btn btn-submit" @click="resetPassword" :disabled="!isValid">
          {{ buttonResetLabel }}
        </button>
      </div>
      <Modal :show="showVerificationSentModal" :title="modal.title" :helpText="modal.helpText" :okButton="modal.okBtnTitle" @modalCallback="modalCallback"></Modal>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import isEmpty from "lodash/isEmpty";
import { Auth } from "aws-amplify";
import Modal from "@/components/participant-portal/common/modal";
import { Widget, Validations, ParticipantPortal } from "@/components/services/participant-service";

export default {
  name: "auth-forgot-reset",
  props: ["eventType", "data", "phoneFlag", "mobile"],
  components: { Modal },
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      validate: new Validations(),
      username: "",
      tabindex: 1,
      password: null,
      newPassword: null,
      otp: ["", "", "", "", "", ""],
      modal: {
        title: "",
        helpText: "",
        okBtnTitle: "",
        cancelBtnTitle: ""
      },
      passwordValidations: {
        isValidLetter: null,
        isValidNumber: null,
        isValidSpecial: null,
        isValidLength: null
      },
      parsswordValidator: {
        minLength: 8,
        minLetter: 1,
        minNumber: 1,
        minSpecial: 1,
        regSpecial: new RegExp("[!@#$%&]", "g"),
        regLetter: new RegExp(/\p{L}/, "gu"),
        regNumber: new RegExp(/\p{N}/, "gu")
      },
      usernameValidation: {
        isValidUnique: null,
        isValidSpecial: null,
        isValidLength: null
      },
      usernameValidator: {
        minLength: 8,
        minLetter: 0,
        minNumber: 0,
        minSpecial: 0,
        regSpecial: new RegExp(/^[\p{L}\p{N}][\p{L}\p{N}.@_-]*[\p{L}\p{N}]$/, "gu"),
        regLetter: new RegExp(/\p{L}/, "gu"),
        regNumber: new RegExp(/\p{N}/, "gu")
      },

      showError: false,
      confirmEnable: true,
      errorMsg: false,
      showVerificationSentModal: false
    };
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    isValidOtp() {
      const isValid = this.otp.filter(e => e !== "" && e !== null && e !== undefined);
      return isValid.length == 6;
    },
    buttonResetLabel() {
      return this.eventType == "username" ? this.widget.translate("rsb_submit", "Submit") : this.widget.translate("text_forgopswd", "Reset Password");
    },
    isCognitoEnabled() {
      return this.$store.getters.pwebCognitoAuthentication;
    },
    isPwdEmpty() {
      return isEmpty(this.password) || isEmpty(this.newPassword);
    },
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    lang() {
      return this.globalElements && this.globalElements.language && this.globalElements.language.language_culture ? this.globalElements.language.language_culture : "en";
    },
    isValid() {
      let areFieldOptionsValid = false;
      if (this.eventType == "username") {
        const filterKeys = ["isValidUnique", "isValidSpecial", "isValidLength"];
        const validOptions = Object.entries(this.usernameValidation).filter(e => filterKeys.includes(e[0]) && e[1] == true);
        areFieldOptionsValid = validOptions.length >= 3;
      } else {
        const filterKeys = ["isValidLetter", "isValidNumber", "isValidSpecial", "isValidLength"];
        const validOptions = Object.entries(this.passwordValidations).filter(e => filterKeys.includes(e[0]) && e[1] == true);
        areFieldOptionsValid = validOptions.length >= 4;
      }

      if (areFieldOptionsValid) {
        return this.password == this.newPassword;
      } else {
        return false;
      }
    },
    obfuscatedIdentity() {
      if (this.data.cognitoEmail) {
        return this.data.cognitoEmail;
      } else {
        const obscureEmail = email => {
          const [name, domain] = email.split("@");
          const [dName, dTag] = domain.split(".");
          return `${name[0]}${new Array(name.length).join("*")}@${dName[0]}${new Array(dName.length).join("*")}.${dTag}`;
        };
        const obscurePhone = (countryCode, phone) => {
          const phoneSplits = phone.split("");
          return `${countryCode}${phoneSplits[0]}${new Array(phoneSplits.length - 2).join("*")}${phoneSplits[phoneSplits.length - 2]}${phoneSplits[phoneSplits.length - 1]}`;
        };
        return this.data.email ? obscureEmail(this.data.email) : obscurePhone("+" + this.mobile.country.dialCode, this.mobile.number.significant);
      }
    }
  },
  methods: {
    modalCallback() {},
    setModalDetails() {
      this.modal.title = this.widget.translate("pweb_title_verification_code_sent", "Verification Code Sent");
      this.modal.helpText = this.widget.translate("label_verification_code_sent", "An email with a code to reset your password has been sent to you.");
      this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
    },
    validatePassword(password) {
      this.passwordValidations = this.validate.password(password, this.parsswordValidator);
    },
    validateUsername(username) {
      const that = this;
      Object.assign(this.usernameValidation, this.validate.validateUsername(username, this.usernameValidator));
      if (username !== "") {
        this.portal
          .cognitoCheckUsername(username)
          .then(res => {
            that.usernameValidation.isValidUnique = res.errorCode == null;
          })
          .catch(() => {
            const message = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
            this.$toastr.error(message);
          });
      } else {
        that.usernameValidation = {
          isValidUnique: null,
          isValidSpecial: null,
          isValidLength: null
        };
      }
    },
    verifyOtp() {
      const isValid = this.otp.filter(e => e !== "" && e !== null && e !== undefined);
      return isValid.length == 6 ? this.otp.join("") : false;
    },
    navigate(password) {
      if (this.eventType == "username") {
        this.$emit("updateActiveScreen", {
          key: "resetPasswordCompleted",
          flagKey: "createUsername",
          flagChild: "newPassword",
          flagValue: password
        });
      } else if (this.eventType == "password") {
        this.$emit("updateActiveScreen", {
          key: "resetPasswordCompleted",
          flagKey: "resetPassword",
          flagChild: "newPassword",
          flagValue: password
        });
      } else {
        this.$emit("updateActiveScreen", {
          key: "resetPasswordCompleted",
          flagKey: "resetPassword",
          flagChild: "newPassword",
          flagValue: password
        });
      }
    },
    resetCognitoPassword(postData) {
      Auth.forgotPasswordSubmit(postData.username, postData.otp, postData.password)
        .then(() => {
          const title = this.widget.translate("CHANGED_PASSWORD", "Password changed successfully.");
          this.$toastr.success(title);
          this.$router.push({ name: "participants-portal-auth-login" });
        })
        .catch(() => {
          const title = this.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
          this.$toastr.error(title);
        });
    },
    createUsername(postData) {
      const successCallback = valid => {
        if (valid) {
          this.$api.createParticipantUsernameWeb(postData).then(
            () => {
              const title = this.widget.translate("label_username_created", "Username created successfully.");
              this.$toastr.success(title);
              this.$router.push({ name: "participants-portal-auth-login" });
            },
            error => {
              const message = this.widget.translate(error.message, "Problem in fetching profile details.");
              this.$toastr.error(message);
            }
          );
        }
      };
      if (this.eventType != "username") {
        if (this.phoneFlag == "phone") {
          postData.mobile = this.mobile.number.significant;
          postData.countryCode = "+" + this.mobile.country.dialCode;
          delete postData.email;
        }
        successCallback(true);
      } else if (this.eventType == "username") {
        successCallback(true);
      } else {
        this.isOtpValid(this.otp.join("")).then(successCallback);
      }
    },
    resetPassword() {
      let postData = this.data;
      postData.username = postData.username.toLowerCase();
      if (this.eventType == "password" && this.isCognitoEnabled) {
        postData.otp = this.verifyOtp();
      }
      if (this.password == this.newPassword) {
        if (this.eventType == "username") {
          postData.username = this.username.toLowerCase();
          postData.password = this.password;
          if (this.phoneFlag == "phone") {
            postData.mobile = this.mobile.number.significant;
            postData.countryCode = "+" + this.mobile.country.dialCode;
          }
          this.createUsername(postData);
        } else {
          this.resetCognitoPassword({
            username: this.data.username.toLowerCase(),
            otp: this.data.otp,
            password: this.password
          });
        }
      } else {
        const title = this.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
        this.$toastr.error(title);
      }
    },
    resendOtp() {
      nprogress.start();
      this.portal
        .cognitoForgotUsername(this.data.username.toLowerCase())
        .then(() => {
          this.otp = ["", "", "", "", "", ""];
          this.$toastr.success(this.widget.translate("label_verification_code_resent", "Verification code has been resent."));
          nprogress.done();
        })
        .catch(errorMessage => {
          nprogress.done();
          if (errorMessage) {
            this.$toastr.error(errorMessage);
          }
        });
    },
    isOtpValid(otp) {
      const that = this;
      return new Promise((resolve, reject) => {
        if (otp && that.eventType == "password" && that.pwebCognitoAuthentication) {
          resolve(true);
        } else if (otp) {
          that.$api
            .ForgotUsernameOtpVerify({
              email: that.data.email.toLowerCase(),
              otp: otp,
              otpType: "CREATE_USERNAME_OTP",
              deviceType: "web"
            })
            .then(
              res => {
                if (res.data.errorCode == null) {
                  resolve(true);
                } else {
                  const title = that.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
                  that.$toastr.error(title);
                  reject(false);
                }
              },
              () => {
                const title = that.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
                that.$toastr.error(title);
                reject(false);
              }
            );
        } else {
          const title = that.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
          that.$toastr.error(title);
          reject(false);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.f-14 {
  font-size: 14px;
}
.validation-list {
  margin-left: 5px;
}

ul.validation-list li {
  list-style-type: disc !important;
  padding-top: 5px;
  font-size: 12px;
  color: #08131f;
}

.checkbox-wrapper {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    color: #b0bac9;
    text-align: left;
    li {
      margin: 0;
      list-style-type: none !important;
      span {
        margin-right: 8px;
        display: inline-block;
        vertical-align: middle;
        &.initial-state {
          border: 1px solid rgba(0, 0, 0, 0.6);
          min-width: 13px;
          min-height: 13px;
          border-radius: 2px;
        }
        &.success {
          background: url("/static/img/participant-web-img/success-icon.svg") no-repeat center;
          min-height: 15px;
          min-width: 15px;
          border: 0;
        }
        &.error {
          background: url("/static/img/participant-web-img/error-icon.svg") no-repeat center;
          min-height: 15px;
          min-width: 15px;
          border: 0;
        }
      }

      @keyframes spinner-border {
        to {
          transform: rotate(360deg);
        }
      }

      .spinner-border {
        display: inline-block;
        width: 13px;
        height: 13px;
        vertical-align: text-bottom;
        border: 0.2rem solid currentColor;
        border-right-color: transparent;
        // stylelint-disable-next-line property-blacklist
        border-radius: 50% !important;
        animation: spinner-border 0.75s linear infinite;
      }

      .spinner-border-sm {
        width: 13px;
        height: 13px;
        border-width: 0.2rem;
      }
    }
  }
}
.forgot-pwd-wrapper .icon-checkmark {
  max-width: 22px;
  width: 100%;
  position: absolute;
  right: -30px;
}
.resend-text {
  color: var(--secondary);
  font-weight: 600;
}
</style>
